import React, { useState } from 'react';
import { Popover, Button, Menu } from 'antd';
import PropTypes from 'prop-types';
import { MoreOutlined } from '@ant-design/icons';
import { getUniqueId } from '../../helpers/helper.functions';
import './index.scss';
import { translateThis } from '../../helpers/language.helper';

const AppPopOverMenuv2 = (props) => {
    const { options = [], icon = <MoreOutlined rotate={90} /> } = props;
    const [open, setOpen] = useState(false);
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    /**
     * Invokes when the popover is closed
     */
    const handleCloseMenu = () => {
        setOpen(false);
    };

    const menu = (
        <Menu style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            {options.map((option) => <Menu.Item style={{ border: "1px solid #fff", margin: "3px" }} key={`${getUniqueId()}-${option.label}`} onClick={() => {
                if (typeof option.onClick === "function") {
                    option.onClick()
                }
                // handleCloseMenu();
            }}>{option.label}
            </Menu.Item>
            )}
        </Menu>
    );


    return (
        <>
            <Popover
                content={menu}
                open={open}
                onOpenChange={handleOpenChange}
                placement="topRight"
                trigger="click" {...props}>
                <button
                    className="text-sm font-medium"
                    style={{
                        background: 'linear-gradient(136.67deg, #7517F8 8.34%, #C438EF 95.26%)',
                        border: 'none',
                        borderRadius: '50px',
                        padding: '5px 15px',
                        color: 'white',
                        fontFamily: 'var(--Inter)',
                        fontWeight: '700',
                        fontSize: '13px',
                        cursor: 'pointer',
                        minWidth: '100px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '5px'
                    }}
                >
                    <svg style={{ color: "#fff" }} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-white">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                    </svg>
                    {translateThis('Columns')}
                </button>

            </Popover>
        </>
    )
}
AppPopOverMenuv2.propTypes = {
    icon: PropTypes.any,
    options: PropTypes.array,
}

export default AppPopOverMenuv2;